<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <create-cust-cat />
      </v-col>
      <v-col cols="8">
        <table-cust-cat />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'CustomerCategoryIndex',
  components: {
    CreateCustCat: () => import('./Create'),
    TableCustCat: () => import('./Table'),
  },
}
</script>
